import { Box, SxProps, Theme, Typography } from '@mui/material';

import { ApplicationTypes } from '@/models/ApplicationType';
import { PartnerProps } from '@/models/Partner';
import { PartnerDashboardDetailsProps } from '@/models/PartnerDashboard';
import { GrowthAwardProgramIds, ProgramNames } from '@/models/Program';

import { PartnerYearsRecognizedRow } from './PartnerYearsRecognizedRow';

type Props = {
  active: boolean;
  partnerInfo: PartnerDashboardDetailsProps;
  selectedProgramId: ProgramNames;
  tabFormSx: SxProps<Theme>;
  sectionSx: SxProps<Theme>;
  sectionTitleSx: SxProps<Theme>;
  onDraftPartnerYearsRecognizedChange: (partner: PartnerProps) => void;
};

export function AwardsTab({
  active,
  partnerInfo,
  selectedProgramId,
  tabFormSx,
  sectionSx,
  sectionTitleSx,
  onDraftPartnerYearsRecognizedChange,
}: Props) {
  return (
    <Box sx={{ ...(active ? tabFormSx : { display: 'none' }) }}>
      <Box sx={sectionSx}>
        <Typography variant='h6' sx={sectionTitleSx}>
          Years Awarded
        </Typography>
        <PartnerYearsRecognizedRow
          programId={selectedProgramId}
          partnerInfo={partnerInfo}
          onDraftPartnerYearsRecognizedChange={onDraftPartnerYearsRecognizedChange}
          applicationTypeId={ApplicationTypes.Standard}
        />
      </Box>

      {GrowthAwardProgramIds.includes(selectedProgramId) && (
        <Box sx={sectionSx}>
          <Typography variant='h6' sx={sectionTitleSx}>
            Growth Award Years Awarded
          </Typography>
          <PartnerYearsRecognizedRow
            programId={selectedProgramId}
            partnerInfo={partnerInfo}
            onDraftPartnerYearsRecognizedChange={onDraftPartnerYearsRecognizedChange}
            applicationTypeId={ApplicationTypes.GrowthAward}
          />
        </Box>
      )}
    </Box>
  );
}
